<template>
  <div class="mt-4 mb-4">
    <b>{{label}}</b>
    <br>
    <VueTimepicker class="mt-2" v-model="value"></VueTimepicker>
  </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

export default {
  props: ['label', 'value'],
  components: { VueTimepicker },
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>

<style>
</style>
